import React from "react";

export const StatusPill = ({ status }) => {
  const map = {
    Available: "pill pill-green",
    Reserved: "pill pill-yellow",
    Rented: "pill pill-blue",
    Maintenance: "pill pill-yellow",
    Disabled: "pill pill-red",
    "Picked Up": "pill pill-blue",
    Returned: "pill pill-gray",
    Overdue: "pill pill-red",
    Cancelled: "pill pill-gray",
    Open: "pill pill-red",
    Billed: "pill pill-yellow",
    Paid: "pill pill-green",
    Disputed: "pill pill-yellow",
    paid: "pill pill-green",
    partial: "pill pill-yellow",
    unpaid: "pill pill-red",
  };
  const cls = map[status] || "pill pill-gray";
  return <span className={cls}>{status}</span>;
};

export const PageHeader = ({ title, subtitle, action, testId }) => (
  <div className="flex flex-wrap items-end justify-between gap-3 mb-5 lg:mb-7" data-testid={testId}>
    <div>
      <div className="overline mb-1">{subtitle || "Section"}</div>
      <h1 className="font-heading text-3xl lg:text-4xl font-bold tracking-tight">{title}</h1>
    </div>
    {action}
  </div>
);

export const EmptyState = ({ title, description, action, testId }) => (
  <div className="text-center py-12 px-6 border border-dashed border-gray-300 rounded-lg bg-gray-50/50" data-testid={testId}>
    <div className="font-heading text-lg font-semibold">{title}</div>
    {description && <div className="text-sm text-gray-500 mt-1.5 mb-4">{description}</div>}
    {action}
  </div>
);

export function readImageAsBase64(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}
